import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ResponseDialogComponent } from '@app/@shared/dialogs/response/response-dialog.component';
import { SearchUsersComponent } from '@app/@shared/dialogs/search-users/search-users.component';
import { CommonDataDTO } from '@app/requests/model/combos-model';
import { AdminStore } from '@app/users/admin-service/admin-service.store';
import {
  ActionEnum,
  DetailedUser,
  RequestAttributionsByProfileDTO,
  RequestCreateUsersDTO,
  RequestDeleteUsersDTO,
  RequestDetailUsersDTO,
  RequestDivisionDTO,
  RequestModifyUsersDTO,
  RequestOwnPasswordDTO,
  RequestVendorByFilterDTO,
  ResponseAttributionsByProfileDTO,
  ResponseBrandDTO,
  ResponseDetailUsersDTO,
  ResponsePasswordDTO,
  UserDetailResponseDTO,
} from '@app/users/model/users-model';
import { UsersStore } from '@app/users/users-service/users.store';
import { UsersApiService } from '@app/users/users-services/users-api.service';
import { LoaderGenericService } from '@app/@shared/loader-generic/loader-generic.service';
import { CustomValidatorsService } from '@app/@shared/custom-validators/custom-validators.service';
import { FINANCIAL_PRODUCT_AUTO } from '@app/@core/constants/requests.constants';
import { TranslateService } from '@ngx-translate/core';
import { CredentialsService } from '@app/login';
import { ProfileDTO } from '@app/user-profiles/model/user-profiles-model';

import {
  ADMINISTRATOR,
  BUSINESS_DIRECTOR,
  CDS,
  CHAIN,
  COMMERCIAL_EXTERNAL,
  COMMERCIAL_INTERNAL,
  DDGG,
  DDGG_WEB,
  ERROR_USER_DUPLICATED,
  ESTABLISHMENT,
  MACRO_CHAIN,
  MACRO_OFFICE,
  OFFICE_BS,
  OFFICE_DIRECTOR,
  PRESCRIBER,
  VENDOR,
} from '@core/constants/users.constants';
import { UserDivisions } from '@app/@core/constants/user-credentials.constants';

const FORM_PARAM_USER = 'user';
const FORM_PARAM_CHECK_USER_WEB_SERVICE = 'checkUserWebService';
const FORM_PARAM_PASSWORD_WEB_SERVICE = 'passwordWebService';
const FORM_PARAM_DIVISION = 'division';
const FORM_PARAM_RADIO_BUTTON_TYPE = 'radioButtonType';
const FORM_PARAM_NAME_WEB_SERVICE = 'nameWebService';
const FORM_PARAM_VENDOR = 'vendor';
const FORM_PARAM_PROFILE = 'perfil';
const FORM_PARAM_BRAND = 'brand';
const FORM_PARAM_EMAIL = 'email';
const FORM_PARAM_PASSWORD = 'password';
const FORM_PARAM_EXTERNAL_COMMERCIAL = 'externalComercial';
const FORM_PARAM_ATTRIBUTIONS = 'atributions';
const FORM_PARAM_OFFICES = 'offices';
const FORM_PARAM_CHAINS = 'chains';

@Component({
  selector: 'scf-register-user',
  templateUrl: './register-user.component.html',
  styleUrls: ['./register-user.component.scss'],
})
export class RegisterUserComponent implements OnInit {
  @Input() mode: string;

  isNameSelected: boolean = false;
  acceptButtonDisabled: boolean = true;
  createUserButtonDisabled: boolean = true;
  isSearchButtonDisabled: boolean;
  isUserSelected: boolean = false;
  selectedName: string;
  dynamicName: string;
  isSellerSelected: boolean = false;
  checked: boolean = false;
  userTypesList: CommonDataDTO[] = [];
  selectNameForm: FormGroup;
  userCharacteristicsForm: FormGroup;
  commercialPersonalDataForm: FormGroup;
  actionUser: ActionEnum;
  isWebService: boolean = false;
  externalComercialList: CommonDataDTO[] = [];
  chainList: CommonDataDTO[] = [];
  officeList: CommonDataDTO[] = [];
  userInfoDetail: ResponseDetailUsersDTO;
  userDivisionList: CommonDataDTO[];
  userProfilesList: CommonDataDTO[];
  vendorsList: CommonDataDTO[];
  attributionList: ResponseAttributionsByProfileDTO[] = [];
  brandList: ResponseBrandDTO[];
  attributionsSelected: string[] = [];
  userExist: boolean = true;
  userDetail: UserDetailResponseDTO;
  isWebUser: boolean = false;
  userId: string = '';
  showBrand: boolean = true;
  showError: boolean = false;
  divisionCommercial: any;
  userIdCredentials: string;
  userCommercial: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private dialog: MatDialog,
    private adminStore: AdminStore,
    private usersApiService: UsersApiService,
    private usersStore: UsersStore,
    public router: Router,
    private cd: ChangeDetectorRef,
    private loaderGenericService: LoaderGenericService,
    private customValidators: CustomValidatorsService,
    public translateService: TranslateService,
    private credentials: CredentialsService
  ) {}

  ngOnInit() {
    this.loaderGenericService.showSpinner();

    this.userCharacteristicsForm = this.formBuilder.group({
      [FORM_PARAM_USER]: ['', [Validators.required, this.customValidators.validateText]],
      [FORM_PARAM_CHECK_USER_WEB_SERVICE]: [''],
      [FORM_PARAM_PASSWORD_WEB_SERVICE]: [{ value: '', disabled: true }],
      [FORM_PARAM_DIVISION]: [''],
      [FORM_PARAM_RADIO_BUTTON_TYPE]: ['', Validators.required],
      [FORM_PARAM_NAME_WEB_SERVICE]: [''],
      [FORM_PARAM_VENDOR]: [''],
      [FORM_PARAM_PROFILE]: ['', Validators.required],
      [FORM_PARAM_BRAND]: [''],
      [FORM_PARAM_EMAIL]: ['', [Validators.required, this.customValidators.validateEmail]],
      [FORM_PARAM_PASSWORD]: ['', Validators.required],
      [FORM_PARAM_EXTERNAL_COMMERCIAL]: [''],
      [FORM_PARAM_ATTRIBUTIONS]: this.formBuilder.group({}),
    });

    if (
      this.credentials.credentials.userType === COMMERCIAL_INTERNAL ||
      this.credentials.credentials.userType === COMMERCIAL_EXTERNAL
    ) {
      this.userCommercial = true;
      this.divisionCommercial = this.credentials.credentials.division;
      this.userIdCredentials = this.credentials.credentials.userId;
      this.userCharacteristicsForm.controls.division.setValue(this.divisionCommercial);
      this.userCharacteristicsForm.controls.division.disable();
      this.clearControlValidator(FORM_PARAM_DIVISION);
      this.userCharacteristicsForm.controls.externalComercial.disable();
      this.clearControlValidator(FORM_PARAM_EXTERNAL_COMMERCIAL);
      if (this.credentials.credentials.division === UserDivisions.AUTOS) {
        this.showBrand = false;
        //this.disableControl(FORM_PARAM_BRAND);
      }
    }

    this.loadDivisions();
    this.loadUserTypes();

    if (this.mode === 'detail') {
      this.usersStore.DetailedUserObserver().subscribe((data: DetailedUser) => {
        if (data && this.userId.length == 0) {
          this.userId = data.userId;
          let requestDetail = {
            userName: data.username,
            userType: data.userType,
          };

          if (this.userDetail !== null) {
            this.adminStore
              .getUserDetailByUserName(requestDetail)
              .then((dataUserDetail: UserDetailResponseDTO) => {
                if (dataUserDetail) {
                  this.userDetail = dataUserDetail;
                  this.isWebUser = dataUserDetail.userWeb;
                  this.userCharacteristicsForm.controls.user.setValue(dataUserDetail.username);
                  this.userCharacteristicsForm.controls.radioButtonType.setValue(dataUserDetail.userType);

                  if (this.userDetail.division == UserDivisions.AUTOS.toString()) {
                    this.showBrand = false;
                  }

                  this.updateActionUser();

                  if (this.actionUser === ActionEnum.US || this.actionUser === ActionEnum.CO) {
                    this.userCharacteristicsForm.controls.perfil.setValue(dataUserDetail.profileId);
                    this.loadListAttributions();

                    let requestDetail: RequestDetailUsersDTO = {
                      user: dataUserDetail.userId,
                      userClass: '',
                      userType: '',
                      username: dataUserDetail.username,
                    };

                    this.adminStore
                      .getDetailUser(requestDetail)
                      .then((dataDetailUser: ResponseDetailUsersDTO) => {
                        this.userInfoDetail = dataDetailUser[0];
                        this.userCharacteristicsForm.controls.email.setValue(this.userInfoDetail.email);

                        if (this.actionUser === ActionEnum.US) {
                          this.userCharacteristicsForm.controls.division.setValue(
                            this.userInfoDetail.division.toString()
                          );
                          this.userCharacteristicsForm.controls.division.disable();
                          this.userCharacteristicsForm.controls.radioButtonType.disable();
                        }

                        // if (this.actionUser === ActionEnum.US && this.showBrand) {
                        //   this.adminStore
                        //     .getBrands({
                        //       user: dataDetailUser[0].userId,
                        //       userType: '',
                        //       userTypeOut: this.userCharacteristicsForm.controls.radioButtonType.value,
                        //     })
                        //     .then((data: ResponseBrandDTO[]) => {
                        //       this.brandList = data;

                        //       if (this.brandList.length > 0) {
                        //         if (this.brandList.length == 1) {
                        //           console.log(this.brandList[0]);
                        //           if (!(Object.keys(this.brandList[0]).length === 0)) {
                        //             this.userCharacteristicsForm.controls.brand.setValue(dataUserDetail.brand);
                        //             this.enableControl(FORM_PARAM_BRAND);
                        //           } else {
                        //             this.disableControl(FORM_PARAM_BRAND);
                        //           }
                        //         }
                        //       } else {
                        //         this.disableControl(FORM_PARAM_BRAND);
                        //       }

                        //       this.loaderGenericService.stopSpinner();
                        //     })
                        //     .catch((error) => {
                        //       if (!this.showError) {
                        //         this.showError = true;
                        //         this.loaderGenericService.stopSpinner();
                        //         this.openErrorResponseDialog(
                        //           this.translateService.instant('dialog.error.loading.information'),
                        //           true
                        //         );
                        //       }
                        //     });
                        // } else {
                        //   this.disableControl(FORM_PARAM_BRAND);
                        //   this.loaderGenericService.stopSpinner();
                        // }
                      })
                      .catch((error) => {
                        if (!this.showError) {
                          this.showError = true;
                          this.loaderGenericService.stopSpinner();
                          this.openErrorResponseDialog(
                            this.translateService.instant('dialog.error.loading.information'),
                            true
                          );
                        }
                      });
                  } else if (this.actionUser === 'WB') {
                    this.userCharacteristicsForm.controls.perfil.setValue(dataUserDetail.profileId);
                    this.loadListAttributions();
                    this.userCharacteristicsForm.controls.nameWebService.setValue(dataUserDetail.userDesc);
                    if (dataUserDetail.userType === DDGG) {
                      this.checked = true;
                      this.adminStore
                        .getPasswordWS()
                        .then((data: ResponsePasswordDTO) => {
                          this.userCharacteristicsForm.controls.passwordWebService.setValue(data.passwordGenerated);
                          this.loaderGenericService.stopSpinner();
                        })
                        .catch((error) => console.error(error));
                      this.userCharacteristicsForm.controls.email.disable();
                    } else if (
                      dataUserDetail.userType === BUSINESS_DIRECTOR ||
                      dataUserDetail.userType === MACRO_OFFICE ||
                      dataUserDetail.userType === MACRO_CHAIN
                    ) {
                      const requestDetail: RequestDetailUsersDTO = {
                        user: dataUserDetail.userId,
                        userClass: '',
                        userType: '',
                        username: '',
                      };

                      this.adminStore
                        .getDetailUser(requestDetail)
                        .then((dataDetailUser: ResponseDetailUsersDTO) => {
                          if (dataDetailUser) {
                            this.userInfoDetail = dataDetailUser[0];
                            this.userCharacteristicsForm.controls.division.setValue(
                              this.userInfoDetail.division.toString()
                            );
                            this.userCharacteristicsForm.controls.email.setValue(this.userInfoDetail.email);

                            if (dataUserDetail.userType === MACRO_OFFICE) {
                              this.loadOffices().then(() => {
                                this.adminStore
                                  .getOfficesByMacrouser(this.userInfoDetail.userId)
                                  .then((data) => {
                                    const officesMacrouser = data.map((office) => office.id);
                                    this.userCharacteristicsForm.controls.offices.setValue(officesMacrouser);
                                  })
                                  .catch((error) => console.error(error));
                              });
                            } else if (dataUserDetail.userType === MACRO_CHAIN) {
                              this.loadChains().then(() => {
                                this.adminStore
                                  .getChainsByMacrouser(this.userInfoDetail.userId)
                                  .then((data) => {
                                    const chainsMacrouser = [...data];
                                    this.chainList = this.chainList
                                      .concat(chainsMacrouser)
                                      .sort((a, b) => a.value.localeCompare(b.value));
                                    this.userCharacteristicsForm.controls.chains.setValue(
                                      data.map((chain) => chain.id)
                                    );
                                  })
                                  .catch((error) => console.error(error));
                              });
                            }
                          }
                        })
                        .catch((error) => console.error(error));
                    }
                  }
                  if (!this.isWebUser) {
                    for (let control in this.userCharacteristicsForm.controls) {
                      this.userCharacteristicsForm.controls[control].disable();
                    }
                  }
                }
              })
              .catch((error) => {
                console.log(error);
              })
              .finally(() => this.loaderGenericService.stopSpinner());
          }
        } else {
          this.goBack();
        }
      });
    }
  }

  ngAfterViewInit() {
    this.cd.detectChanges();
  }

  onFocusOutEvent(event: any) {
    if (this.userCharacteristicsForm.controls.user.invalid) {
      this.userExist = true;
    } else {
      if (this.userDetail && this.userDetail.username === event.target.value) {
        this.userCharacteristicsForm.controls.user.setErrors(null);
        this.userExist = true;
      } else {
        if (event.target.value.length > 0) {
          let requestDetail: RequestDetailUsersDTO = {
            user: '',
            userClass: '',
            userType: '',
            username: event.target.value,
          };

          this.adminStore
            .getDetailUser(requestDetail)
            .then((data: ResponseDetailUsersDTO) => {
              if (data) {
                this.userCharacteristicsForm.controls.user.setErrors({ userExist: true });
                this.userExist = true;
              }
            })
            .catch((error) => {
              if (error.status === 404) {
                this.userCharacteristicsForm.controls.user.setErrors(null);
                this.userExist = false;
              }
            });
        }
      }
    }
  }

  onChangeWebService(ob: MatCheckboxChange) {
    if (ob.checked) {
      this.isWebService = true;
      this.userCharacteristicsForm.controls.email.disable();
      this.userCharacteristicsForm.controls.email.setValue(null);
      this.adminStore
        .getPasswordWS()
        .then((data: ResponsePasswordDTO) => {
          this.userCharacteristicsForm.controls.passwordWebService.setValue(data.passwordGenerated);
        })
        .catch((error) => console.error(error));
    } else {
      this.userCharacteristicsForm.controls.email.enable();
      this.isWebService = false;
    }
  }

  registerUser() {
    this.attributionsSelected = [];
    const formArray = <FormGroup>this.userCharacteristicsForm.get('atributions');
    Object.keys(formArray.controls).forEach((key) => {
      if (formArray.controls[key].value === true) {
        this.attributionsSelected.push(key);
      }
    });

    let attributions = this.attributionsSelected.join(' ');

    let user: RequestCreateUsersDTO = {
      password: this.userCharacteristicsForm.controls.password.value,
      filterAttributions: attributions,
      profile: this.userCharacteristicsForm.controls.perfil.value,
      userDescription: this.userCharacteristicsForm.controls.nameWebService.value,
      userType: this.userCharacteristicsForm.controls.radioButtonType.value,
      brand: this.userDetail?.brand ? this.userDetail?.brand : '',
      action: this.actionUser,
      user:
        this.actionUser === ActionEnum.US || this.actionUser === ActionEnum.CO
          ? this.userInfoDetail.userId
          : this.isWebService
          ? this.userCharacteristicsForm.controls.user.value
          : '',
      webUser: this.userCharacteristicsForm.controls.user.value ? this.userCharacteristicsForm.controls.user.value : '',
      email: this.userCharacteristicsForm.controls.email.value ? this.userCharacteristicsForm.controls.email.value : '',
      commercialUser: this.getCommercialUserId(),
      divisionId: this.userCharacteristicsForm.controls.division.value
        ? this.userCharacteristicsForm.controls.division.value
        : '',
    };

    if (this.isUserTypeMacroOffice()) {
      user = {
        ...user,
        filterOffices: this.userCharacteristicsForm.controls.offices.value
          ? this.userCharacteristicsForm.controls.offices.value.join(',')
          : '',
      };
    } else if (this.isUserTypeMacroChain()) {
      user = {
        ...user,
        filterChains: this.userCharacteristicsForm.controls.chains.value
          ? this.userCharacteristicsForm.controls.chains.value.join(',')
          : '',
      };
    }

    this.adminStore
      .createUser(user)
      .then((data: boolean) => {
        if (this.isWebService) {
          const request: RequestOwnPasswordDTO = {
            user: user.user,
            password: this.userCharacteristicsForm.controls.passwordWebService.value,
            noExpires: true,
          };
          this.usersApiService.postSetOwnPassword(request).subscribe(
            (password) => {
              password && data
                ? this.openSuccessResponseDialog(this.translateService.instant('create.dialog.ok'), true)
                : this.openErrorResponseDialog(this.translateService.instant('create.dialog.ko'));
            },
            (error) => {
              let errorText =
                error.error.status === 400 ? this.translateService.instant('create.dialog.ko') : 'Error desconocido';
              this.openErrorResponseDialog(errorText);
            }
          );
        } else {
          this.openSuccessResponseDialog(this.translateService.instant('create.dialog.ok'), true);
        }
      })
      .catch((error) => {
        const { message } = error?.error;
        let errorMsg = message?.includes(ERROR_USER_DUPLICATED)
          ? this.translateService.instant('dialog.error.user.duplicated')
          : this.translateService.instant('create.dialog.active.ko', {
              userName: this.userCharacteristicsForm.controls.user.value,
            });
        this.openResponseDialog(errorMsg, 'icon-ic_circle_cross');
      });
  }

  private getCommercialUserId() {
    if (this.userCommercial) {
      return this.userCharacteristicsForm.controls.radioButtonType.value === VENDOR
        ? this.userCharacteristicsForm.controls.vendor.value
        : this.userInfoDetail?.userId;
    } else {
      if (this.userCharacteristicsForm.controls.radioButtonType.value === VENDOR)
        return this.userCharacteristicsForm.controls.vendor.value;
      else return this.userCharacteristicsForm.controls.externalComercial.value;
    }
  }

  modifyUser() {
    this.loaderGenericService.showSpinner();
    this.attributionsSelected = [];
    const formArray = <FormGroup>this.userCharacteristicsForm.get('atributions');
    Object.keys(formArray.controls).forEach((key) => {
      if (formArray.controls[key].value === true) {
        this.attributionsSelected.push(key);
      }
    });

    let attributions = this.attributionsSelected.join(' ');

    let userModify: RequestModifyUsersDTO = {
      brand: this.userDetail?.brand ? this.userDetail?.brand : '',
      email: this.userCharacteristicsForm.controls.email.value,
      filterAttributions: attributions,
      password: this.userCharacteristicsForm.controls.password.value,
      profile: this.userCharacteristicsForm.controls.perfil.value,
      typeBS: this.userInfoDetail.typeBS,
      webUser: this.userCharacteristicsForm.controls.user.value,
      webUserOld: this.userDetail.username,
      userType: this.userDetail.userType,
    };

    const userType = this.userCharacteristicsForm.controls.radioButtonType.value;
    if (userType === MACRO_OFFICE || userType === MACRO_CHAIN || userType === BUSINESS_DIRECTOR) {
      userModify = {
        ...userModify,
        divisionId: this.userCharacteristicsForm.controls.division.value,
        filterOffices: userType === MACRO_OFFICE ? this.userCharacteristicsForm.controls.offices.value.join(',') : '',
        filterChains: userType === MACRO_CHAIN ? this.userCharacteristicsForm.controls.chains.value.join(',') : '',
      };
    }

    this.adminStore
      .modifyUser(userModify)
      .then((data: boolean) => {
        if (data) {
          this.loaderGenericService.stopSpinner();
          this.openSuccessResponseDialog(this.translateService.instant('modify.dialog.ok'), true);
        }
      })
      .catch((error) => {
        this.loaderGenericService.stopSpinner();
        this.openErrorResponseDialog(this.translateService.instant('modify.dialog.ko'));
      });
  }

  deleteUser() {
    this.loaderGenericService.showSpinner();
    let userDelete: RequestDeleteUsersDTO = {
      userId: this.userId,
      password: this.userCharacteristicsForm.controls.password.value,
      userWeb: this.userCharacteristicsForm.controls.user.value,
      userType: this.userDetail.userType,
    };

    this.adminStore
      .deleteUser(userDelete)
      .then((data: boolean) => {
        this.loaderGenericService.stopSpinner();
        this.openSuccessResponseDialog(this.translateService.instant('delete.dialog.ok'), true);
      })
      .catch((error) => {
        this.loaderGenericService.stopSpinner();
        this.openResponseDialog(error.error.message, 'icon-ic_circle_cross');
      });
  }

  reset() {
    this.userInfoDetail = null;
    this.attributionList = [];
    this.chainList = [];
    this.officeList = [];
    this.userCharacteristicsForm.controls.checkUserWebService.reset();
    this.userCharacteristicsForm.controls.passwordWebService.reset();
    this.userCharacteristicsForm.controls.passwordWebService.reset();
    this.userCharacteristicsForm.controls.perfil.reset();
    //this.userCharacteristicsForm.controls.brand.reset();
    this.userCharacteristicsForm.controls.email.reset();
    this.userCharacteristicsForm.controls.password.reset();
    this.userCharacteristicsForm.controls.email.enable();
  }

  hasLoadedAtributions() {
    return this.attributionList.length > 0 ? true : false;
  }

  openDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '90%';
    dialogConfig.maxWidth = '700px';
    dialogConfig.data = {
      typeOut: this.userCharacteristicsForm.controls.radioButtonType.value,
      division: this.userCharacteristicsForm.controls.division.value,
      typerCreate: this.userCharacteristicsForm.controls.radioButtonType.value,
      idExtenalCommercial: this.userCharacteristicsForm.controls.externalComercial.value,
      action: this.actionUser,
      infoUser: this.userInfoDetail,
      vendor: this.userCharacteristicsForm.controls.vendor.value,
    };
    dialogConfig.disableClose = true;

    const modalDialog = this.dialog.open(SearchUsersComponent, dialogConfig);

    modalDialog.afterClosed().subscribe(
      (result: any) => {
        console.log(result);
        if (result) {
          let requestDetail: RequestDetailUsersDTO = {
            user: result.id,
            userClass: '',
            userType:
              this.userCharacteristicsForm.controls.radioButtonType.value === VENDOR
                ? ESTABLISHMENT
                : this.userCharacteristicsForm.controls.radioButtonType.value,
            username: '',
          };

          let requestUserDetail = {
            userId: result.id,
            userType:
              this.userCharacteristicsForm.controls.radioButtonType.value === VENDOR
                ? ESTABLISHMENT
                : this.userCharacteristicsForm.controls.radioButtonType.value,
          };

          this.adminStore
            .getUserDetailByUserId(requestUserDetail)
            .then((dataUserDetail: UserDetailResponseDTO) => {
              this.userDetail = dataUserDetail;
              this.adminStore
                .getDetailUser(requestDetail)
                .then((data: ResponseDetailUsersDTO) => {
                  this.userInfoDetail = data[0];

                  if (this.userCharacteristicsForm.controls.radioButtonType.value === VENDOR) {
                    this.loadVendors();
                    this.userCharacteristicsForm.controls.vendor.setValidators(Validators.required);
                  }

                  // if (this.actionUser === ActionEnum.US && this.showBrand) {
                  //   this.adminStore
                  //     .getBrands({
                  //       user: result.id,
                  //       userType: '',
                  //       userTypeOut: this.userCharacteristicsForm.controls.radioButtonType.value,
                  //     })
                  //     .then((data: ResponseBrandDTO[]) => {
                  //       this.brandList = data;
                  //       if (this.brandList.length > 0 && !(Object.keys(this.brandList[0]).length === 0)) {
                  //         this.userCharacteristicsForm.controls.brand.setValue(this.brandList[0].value);
                  //         this.enableControl(FORM_PARAM_BRAND);
                  //       } else {
                  //         this.disableControl(FORM_PARAM_BRAND);
                  //       }
                  //     })
                  //     .catch((error) => {
                  //       this.loaderGenericService.stopSpinner();
                  //       this.openErrorResponseDialog(
                  //         this.translateService.instant('dialog.error.loading.information'),
                  //         true
                  //       );
                  //       this.disableControl(FORM_PARAM_BRAND);
                  //     });
                  // }
                })
                .catch((error) => {
                  let dialogConfig = new MatDialogConfig();
                  dialogConfig.data = {
                    text: this.translateService.instant('dialog.error.loading.information'),
                    icon: 'icon-ic_circle_cross',
                    noRedirect: true,
                  };
                  const modalDialog = this.dialog.open(ResponseDialogComponent, dialogConfig);
                  modalDialog.afterClosed().subscribe(() => {
                    this.goBack();
                  });
                });
            })
            .catch((error) => console.error(error));
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  onDivisionSelection() {
    const userType = this.userCharacteristicsForm.controls.radioButtonType.value;
    if (userType !== BUSINESS_DIRECTOR) {
      if (userType === MACRO_CHAIN) {
        this.loadChains();
      } else if (userType === MACRO_OFFICE) {
        this.loadOffices();
      } else {
        this.loadExternalCommercials();
      }
    }
  }

  loadExternalCommercials() {
    this.reset();
    let divisionDTO: RequestDivisionDTO = {
      division: this.userCharacteristicsForm.controls.division.value,
    };
    this.adminStore
      .getExternalCommercial(divisionDTO)
      .then((data: CommonDataDTO[]) => (this.externalComercialList = data))
      .catch((error) => console.error(error));

    if (this.userCharacteristicsForm.controls.division.value === FINANCIAL_PRODUCT_AUTO) {
      this.showBrand = false;
      //this.disableControl(FORM_PARAM_BRAND);
    } else {
      if (this.actionUser === ActionEnum.US) {
        this.showBrand = true;
        //this.enableControl(FORM_PARAM_BRAND);
      }
    }
  }

  loadVendors() {
    let requestVendor: RequestVendorByFilterDTO = {
      activate: 'N',
      type: this.userInfoDetail.userType,
      typeOut: this.userCharacteristicsForm.controls.radioButtonType.value,
      user: this.userInfoDetail.userId,
    };

    this.adminStore
      .getVendors(requestVendor)
      .then((data: CommonDataDTO[]) => {
        this.vendorsList = data;
        this.userCharacteristicsForm.controls.vendor.setValue(data[0].id);
      })
      .catch((error) => {
        this.vendorsList = [];
        this.userCharacteristicsForm.controls.vendor.setValue(null);
        console.error(error);
      });
  }

  loadListAttributions() {
    let profileSelected: RequestAttributionsByProfileDTO = {
      profileId: this.userCharacteristicsForm.controls.perfil.value,
    };

    this.adminStore
      .getAttributionsProfile(profileSelected)
      .then((data: ResponseAttributionsByProfileDTO[]) => {
        this.attributionList = data;
        const formArray = <FormGroup>this.userCharacteristicsForm.get('atributions');
        if (formArray !== null) {
          Object.keys(formArray.controls).forEach((key) => {
            formArray.removeControl(key);
          });
        }

        this.attributionList.forEach((x: ResponseAttributionsByProfileDTO) => {
          if (x.status === MACRO_CHAIN) {
            formArray.addControl(x.id.toString(), new FormControl({ value: true, disabled: true }));
          } else {
            if (this.mode === 'detail') {
              let AttrAds = this.userDetail.attributions.find((element) => element.id === x.id);
              if (AttrAds !== undefined) {
                formArray.addControl(x.id.toString(), new FormControl(true));
              } else {
                formArray.addControl(x.id.toString(), new FormControl(false));
              }
            } else {
              formArray.addControl(x.id.toString(), new FormControl(false));
            }
          }
        });
      })
      .catch((error) => {
        if (!this.showError) {
          this.showError = true;
          this.loaderGenericService.stopSpinner();
          this.openErrorResponseDialog(this.translateService.instant('dialog.error.loading.information'), true);
        }
      });
  }

  private loadOffices = async () => {
    this.userCharacteristicsForm.controls.offices.setValue('');
    this.officeList = [];
    return this.adminStore
      .getOffices(this.userCharacteristicsForm.controls.division.value)
      .then((value) => {
        this.officeList = value;
        this.userCharacteristicsForm.controls.offices.setValue(this.officeList.map((off) => off.id));
      })
      .catch((error) => console.error(error));
  };

  private loadChains = async () => {
    this.userCharacteristicsForm.controls.chains.setValue('');
    this.chainList = [];
    return this.adminStore
      .getChainsWithoutMacrochain(this.userCharacteristicsForm.controls.division.value)
      .then((value) => {
        this.chainList = value;
        this.userCharacteristicsForm.controls.chains.setValue(this.chainList.map((ch) => ch.id));
      })
      .catch((error) => console.error(error));
  };

  private loadProfiles = async () => {
    this.adminStore
      .getProfiles({ action: this.actionUser })
      .then(
        (data) => (this.userProfilesList = data),
        (error) => console.error(error)
      )
      .catch((error) => console.error(error));
  };

  private loadUserTypes = async () => {
    this.adminStore
      .getUserTypes()
      .then((data: CommonDataDTO[]) => {
        if (!this.userCommercial) {
          this.userTypesList = data;
        } else {
          this.userTypesList = data.filter((item: CommonDataDTO) => {
            if (
              item.id === CHAIN ||
              item.id === MACRO_CHAIN ||
              item.id === VENDOR ||
              item.id === PRESCRIBER ||
              item.id === ESTABLISHMENT
            ) {
              return item;
            }
          });
        }
      })
      .catch((error) => console.error(error));
  };

  private loadDivisions = async () => {
    this.adminStore
      .getDivisions()
      .then((data: CommonDataDTO[]) => {
        this.userDivisionList = data;
      })
      .catch((error) => console.error(error));
  };

  updateActionUser() {
    this.reset();
    switch (this.userCharacteristicsForm.controls.radioButtonType.value) {
      case CHAIN:
        this.actionUser = ActionEnum.US;
        this.validatorsUS();
        break;
      case ESTABLISHMENT:
        this.actionUser = ActionEnum.US;
        this.validatorsUS();
        break;
      case PRESCRIBER:
        this.actionUser = ActionEnum.US;
        this.validatorsUS();
        break;
      case VENDOR:
        this.actionUser = ActionEnum.US;
        this.validatorsUS();
        this.userCharacteristicsForm.controls.vendor.setValidators([Validators.required]);
        break;
      case CDS:
        this.actionUser = ActionEnum.WB;
        this.validatorsWB();
        break;
      case DDGG_WEB:
        this.actionUser = ActionEnum.WB;
        this.validatorsWB();
        break;
      case OFFICE_BS:
        this.actionUser = ActionEnum.WB;
        this.validatorsWB();
        break;
      case BUSINESS_DIRECTOR:
        this.actionUser = ActionEnum.WB;
        this.validatorsWB();
        break;
      case MACRO_OFFICE:
        this.actionUser = ActionEnum.WB;
        this.validatorsWB();
        break;
      case MACRO_CHAIN:
        this.actionUser = ActionEnum.WB;
        this.validatorsWB();
        if (this.userCommercial) {
          this.userCharacteristicsForm.controls.division.setValue(this.divisionCommercial);
          this.loadChains();
        }
        break;
      case ADMINISTRATOR:
        this.actionUser = ActionEnum.WB;
        this.validatorsWB();
        break;
      case COMMERCIAL_INTERNAL:
        this.actionUser = ActionEnum.CO;
        this.validatorsCO();
        break;
      case COMMERCIAL_EXTERNAL:
        this.actionUser = ActionEnum.CO;
        this.validatorsCO();
        break;
      case DDGG:
        this.actionUser = ActionEnum.CO;
        this.validatorsCO();
        break;
      case OFFICE_DIRECTOR:
        this.actionUser = ActionEnum.CO;
        this.validatorsCO();
        break;
    }

    this.getProfiles(this.userCharacteristicsForm.controls.radioButtonType.value);
  }

  private getProfiles = (id: string) => {
    this.userProfilesList = [];
    this.adminStore
      .getProfilesByUserType(id)
      .then((data) => (this.userProfilesList = data))
      .catch((error) => console.error(error));
  };

  goBack() {
    this.router.navigate(['/users/search', { keepFilter: true }]);
  }

  private validatorsUS() {
    this.clearControlValidator(FORM_PARAM_NAME_WEB_SERVICE);

    //this.clearControlValidator(FORM_PARAM_BRAND);
    //if (this.showBrand) this.addRequiredControlValidation(FORM_PARAM_BRAND);

    if (!this.userCommercial) this.addRequiredControlValidation(FORM_PARAM_DIVISION);

    if (this.mode != 'detail' && !this.userCommercial)
      this.addRequiredControlValidation(FORM_PARAM_EXTERNAL_COMMERCIAL);
    this.clearControlValidator(FORM_PARAM_VENDOR);
    this.clearControlValidator(FORM_PARAM_CHAINS);
    this.clearControlValidator(FORM_PARAM_OFFICES);
  }

  private validatorsCO() {
    this.clearControlValidator(FORM_PARAM_NAME_WEB_SERVICE);
    //this.clearControlValidator(FORM_PARAM_BRAND);
    this.clearControlValidator(FORM_PARAM_DIVISION);
    this.clearControlValidator(FORM_PARAM_EXTERNAL_COMMERCIAL);
    this.clearControlValidator(FORM_PARAM_VENDOR);
    this.clearControlValidator(FORM_PARAM_CHAINS);
    this.clearControlValidator(FORM_PARAM_OFFICES);
  }

  private validatorsWB() {
    this.addRequiredControlValidation(FORM_PARAM_NAME_WEB_SERVICE);
    //this.clearControlValidator(FORM_PARAM_BRAND);
    this.clearControlValidator(FORM_PARAM_DIVISION);
    this.clearControlValidator(FORM_PARAM_EXTERNAL_COMMERCIAL);
    this.clearControlValidator(FORM_PARAM_VENDOR);
    this.validatorMacroUsers();
  }

  private validatorMacroUsers = () => {
    this.removeControl(FORM_PARAM_CHAINS);
    this.removeControl(FORM_PARAM_OFFICES);
    const userType = this.userCharacteristicsForm.controls.radioButtonType.value;
    if (this.isUserTypeMacroUser()) {
      this.userCharacteristicsForm.controls.division.reset();
      this.addRequiredControlValidation(FORM_PARAM_DIVISION);
      if (userType === MACRO_CHAIN) {
        this.userCharacteristicsForm.addControl(FORM_PARAM_CHAINS, new FormControl('', [Validators.required]));
      } else if (userType === MACRO_OFFICE) {
        this.userCharacteristicsForm.addControl(FORM_PARAM_OFFICES, new FormControl('', [Validators.required]));
      }
    }
  };

  checkboxRows(): number {
    return this.attributionList ? this.attributionList.length * 1.25 + 2 : 0; //va a haber 3 chechboxes por linea
  }

  private openErrorResponseDialog = (text: string, redirect?: boolean) => {
    this.openResponseDialog(text, 'icon-ic_circle_cross', redirect);
  };

  private openSuccessResponseDialog = (text: string, redirect?: boolean) => {
    this.openResponseDialog(text, 'icon-ic_circle_check', redirect);
  };

  private openResponseDialog = (text: string, icon: string, redirect?: boolean) => {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      text: text,
      icon: icon,
      noRedirect: true,
    };
    const redirectDialog = this.dialog.open(ResponseDialogComponent, dialogConfig);
    if (redirect) {
      redirectDialog.afterClosed().subscribe(() => {
        this.goBack();
      });
    }
  };

  private disableControl = (name: string) => {
    if (this.userCharacteristicsForm.controls[name]) {
      this.userCharacteristicsForm.controls[name].disable();
      this.addRequiredControlValidation(name);
    }
  };

  private enableControl = (name: string) => {
    if (this.userCharacteristicsForm.controls[name]) {
      this.userCharacteristicsForm.controls[name].enable();
      this.addRequiredControlValidation(name);
    }
  };

  private removeControl(name: string) {
    if (this.userCharacteristicsForm.controls[name]) {
      this.userCharacteristicsForm.removeControl(name);
    }
  }

  private clearControlValidator(name: string) {
    if (this.userCharacteristicsForm.controls[name]) {
      this.userCharacteristicsForm.controls[name].reset();
      this.userCharacteristicsForm.controls[name].clearValidators();
      this.userCharacteristicsForm.controls[name].updateValueAndValidity();
    }
  }

  private addRequiredControlValidation(name: string) {
    if (this.userCharacteristicsForm.controls[name]) {
      this.userCharacteristicsForm.controls[name].setValidators([Validators.required]);
      this.userCharacteristicsForm.controls[name].updateValueAndValidity();
    }
  }

  isUserTypeMacroUser = () =>
    this.isUserTypeMacroChain() || this.isUserTypeMacroOffice() || this.isUserTypeBusinessDirector();
  isUserTypeMacroChain = () => this.userCharacteristicsForm.controls.radioButtonType.value === MACRO_CHAIN;
  isUserTypeMacroOffice = () => this.userCharacteristicsForm.controls.radioButtonType.value === MACRO_OFFICE;
  isUserTypeBusinessDirector = () => this.userCharacteristicsForm.controls.radioButtonType.value === BUSINESS_DIRECTOR;
}
